import {
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  ListItemIcon
} from '@mui/material'
import { Check } from "@mui/icons-material"
import { join, size, toString, map, replace, isNil } from 'lodash/fp'
import { Config } from '../../functions/types'
import { useFormContext } from 'react-hook-form'
import { displayRule } from '../FormInput'
const FormConfirm: React.FC<{
  configs?: Record<string, Config>
}> = ({ configs }): JSX.Element => {
  const { getValues } = useFormContext()
  const data = getValues()
  if (isNil(configs)) return <></>
  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">ご入力内容のご確認</Typography>
      </Box>
      <List>
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} >
          {map(
            (index: number) => {
              const source = `No${toString(index)}`
              const config = configs[source as keyof typeof configs] as Config
              const {
                inputType,
                label
              } = config
              return inputType !== "show" && displayRule(config, data) && (
                <ListItem><ListItemIcon><Check /></ListItemIcon>
                  {(inputType === "text" || inputType === "radio") && <ListItemText primary={label} secondary={data[source]} />}
                  {inputType === "check" && <ListItemText primary={label} secondary={join("\n")(data[source])} />}
                  {(inputType === "date" || inputType === "dates") && <ListItemText primary={label} secondary={replace(/(\d{4})-(\d{2})-(\d{2})/g, "$1年$2月$3日")(data[source])} />}
                </ListItem>)
            })(Array.from(new Array(size(configs)), (_, index) => index + 1))
          }
        </Box>
      </List>
    </Box>
  )
}
export default FormConfirm